import { Dictionary } from "lodash";
import { DesignationDistance } from "react-migration/domains/constraints/designation/hooks/useNearestDesignationQuery";
import { isDefined } from "react-migration/lib/util/isDefined";
import { useKeyIndicatorTags, KeyIndicatorColor } from "react-migration/lib/map/useKeyIndicatorTags";
import { isBeyondMaxDistance } from "./AmenityDistanceInsight";

function getKeyIndicatorColor(count = 0, numberOfAmenities: number) {
  if (count === numberOfAmenities) return KeyIndicatorColor.GREEN;
  if (count >= Math.floor(numberOfAmenities * 0.75)) return KeyIndicatorColor.ORANGE;

  return KeyIndicatorColor.RED;
}

export function useClosestAmenitiesKeyIndicator(
  distanceMap: Dictionary<DesignationDistance | undefined> | undefined,
  numberOfAmenities: number,
  maxDistanceMeters: number
) {
  const keyIndicator = useKeyIndicatorTags(() => {
    const distances = Object.values(distanceMap ?? {}).filter(isDefined);

    const withinMaxDistance = distances?.filter(
      (distance) => !isBeyondMaxDistance(distance.distanceMeters, maxDistanceMeters)
    );

    return [
      {
        color: getKeyIndicatorColor(withinMaxDistance?.length, numberOfAmenities),
        tag: withinMaxDistance?.length ? withinMaxDistance.length.toString() : "None nearby",
      },
    ];
  }, [distanceMap, maxDistanceMeters, numberOfAmenities]);

  return keyIndicator;
}
